import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";
import { HashLink } from "react-router-hash-link";
const Footer = () => {
  return (
    <>
      {/* <!-- ======= Footer ======= --> */}
      <footer id="footer">
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-6 footer-info">
                <div className="footer_logo">
                  <img
                    src="../assets/images/logos/bbpl_logo.png"
                    alt="logo"
                    width="150px"
                    className="pb-3"
                  />
                </div>
                <p>
                  At Bhagirath Biotech Private Limited, we are the catalysts of
                  global trade, a company that thrives on connecting the world
                  through commerce.{" "}
                </p>
              </div>
              <div className="col-lg-3 col-md-6 footer-links">
                <h4>Useful Links</h4>
                <ul>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <Link to="/about">About us</Link>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <Link to="/services">Services</Link>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <HashLink to="/terms#TermsAndConditions">Terms of service</HashLink>
                  </li>
                  <li>
                    <i className="bi bi-chevron-right"></i>{" "}
                    <HashLink to="/privacy#PrivacyAndPolicy">Privacy policy</HashLink>
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 col-md-6 footer-contact">
                <h4>Contact Us</h4>
                <p>
                  <b>Address - Flat No.: 202 Plot No. 65 / A,
                    Esteem Homes Indrapuri Raisen Road,
                    Bhopal, Madhya Pradesh, India 462023</b>
                </p>
                <p>
                  <strong>Email : </strong>
                  <Link to="info@bhagirathbiotech.com" style={{ color: "#5ca595" }}>
                    info@bhagirathbiotech.com
                  </Link>
                  <br />
                  {/* <strong>Phone : </strong>
                  <Link to="tel:+91 7720001932" style={{ color: "#5ca595" }}>
                    +91 7720001932
                  </Link>
                  <br /> */}
                  {/* <strong>Fax : </strong>
                  <Link to="tel:+91 7720001932" style={{ color: "#5ca595" }}>
                    +91 7720001932
                  </Link> */}
                </p>
                {/* <div className="social-links">
                  <Link to="https://twitter.com/bbvmg1223" className="twitter">
                    <i className="bi bi-twitter"></i>
                  </Link>
                  <Link to="https://www.facebook.com/people/Bhagirath-BVM-Grand/61554215402444/" className="facebook">
                    <i className="bi bi-facebook"></i>
                  </Link>
                  <Link to="/" className="instagram">
                    <i className="bi bi-instagram"></i>
                  </Link>
                  <Link to="https://www.linkedin.com/in/bbvm-grand-4b88472a2" className="linkedin">
                    <i className="bi bi-linkedin"></i>
                  </Link>
                </div> */}
              </div>
              <div className="col-lg-3 col-md-6 footer-newsletter">
                <h4>Coming Soon</h4>
                <button><Link to="/contact">Get in Touch</Link></button>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="copyright">
            &copy;{new Date().getFullYear()}{" "} Copyright <strong>Bhagirath Biotech Private Limited</strong>.
            All Rights Reserved
          </div>
          {/* <div className="credits">
            Designed & maintained by
            <Link to="/" style={{ color: "#5ca595" }}>
              {" "}
              Bhagirath Technologies
            </Link>
          </div> */}
        </div>
      </footer>
      {/* <!-- End Footer --> */}
    </>
  );
};

export default Footer;
